import { BRAND_NAME, language } from "@chef/constants";

export const intl = (
  {
    no: {
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_HAS_BEEN_RECEIVED:
        "Din forespørsel om å slette kontoen din er mottatt",
      FOR_SECURITY_REASONS:
        "Du vil motta en bekreftelse fra oss når sletteprosessen har startet, normalt innen 24 timer. Takk for at du har vært kunde hos oss, og vi håper å se deg igjen i fremtiden! I mellomtiden vil kontoen din være pauset.",
      I_UNDERSTAND: "Jeg forstår",
      CONFIRM_THAT: "Sjekk om det finnes",
      OUTSTANDING_PAYMENTS_EXISTS: "utestående betalinger",
      DO_YOU_HAVE_OTHER_QUESTIONS: "Har du andre spørsmål?",
      CONTACT_SUPPORT: "Kontakt kundeservice",
      DELETE_ACCOUNT: "Slett konto",
    },

    se: {
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_HAS_BEEN_RECEIVED:
        "Din begäran om att radera ditt konto har mottagits",
      FOR_SECURITY_REASONS:
        "Du mottar en bekräftelse från oss när raderingsprocessen har påbörjats, vanligtvis inom 24 timmar. Tack för att varit kund hos oss, vi hoppas att få välkomna dig tillbaka igen i framtiden! Under tiden är ditt konto pausat.",
      I_UNDERSTAND: "Jag förstår",
      CONFIRM_THAT: "Kontrollera om",
      OUTSTANDING_PAYMENTS_EXISTS: "utomstående betalningar finns",
      DO_YOU_HAVE_OTHER_QUESTIONS: "Har du andra frågor?",
      CONTACT_SUPPORT: "Kontakta kundtjänst",
      DELETE_ACCOUNT: "Radera konto",
    },

    dk: {
      YOUR_REQUEST_TO_DELETE_YOUR_ACCOUNT_HAS_BEEN_RECEIVED:
        "Din anmodning om at slette din konto er modtaget",
      FOR_SECURITY_REASONS:
        "Du vil modtage en bekræftelse fra os, når sletningsprocessen er startet - normalt inden for 24 timer. Mange tak for denne gang. Vi håber at se dig igen på et senere tidspunkt.  I mellemtiden vil din konto være sat på pause.",
      I_UNDERSTAND: "Jeg forstår",
      CONFIRM_THAT: "Tjek om der er",
      OUTSTANDING_PAYMENTS_EXISTS: "udestående betalinger",
      DO_YOU_HAVE_OTHER_QUESTIONS: "Har du andre spørgsmål?",
      CONTACT_SUPPORT: "Kontakt kundeservice",
      DELETE_ACCOUNT: "Slet konto",
    },
  } as const
)[language];

export const brand = (
  {
    AMK: {
      MY_MENU_PATH: "/app/min-matkasse",
      PAYMENTS_PATH: "/app/min-konto/betaling",
      CONTACT_US_PATH: "/app/min-konto/kontakt",
    },

    GL: {
      MY_MENU_PATH: "/app/min-matkasse",
      PAYMENTS_PATH: "/app/min-konto/betaling",
      CONTACT_US_PATH: "/app/min-konto/kontakt",
    },

    LMK: {
      MY_MENU_PATH: "/mina-sidor/min-meny",
      PAYMENTS_PATH: "/mina-sidor/mitt-konto/betalningsoversikt",
      CONTACT_US_PATH: "/mina-sidor/mitt-konto/kontaktuppgifter",
    },

    RN: {
      MY_MENU_PATH: "/app/min-menu",
      PAYMENTS_PATH: "/app/min-konto/betaling",
      CONTACT_US_PATH: "/app/min-konto/kundeservice",
    },
  } as const
)[BRAND_NAME];
